import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Image, Trash, EyeFill, EyeSlash, EyeSlashFill } from 'react-bootstrap-icons';

import styles from '../Shop.module.css'
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';

const Status = {
    ACTIVE: {
        tooltip: 'Active',
        className: 'text-success',
    },
    DRAFT: {
        tooltip: 'Draft',
        className: 'text-warning',
    },
    ARCHIVED: {
        tooltip: 'Archived',
        className: 'text-danger',
    },
};

export const Item = ({ item, onClick, onDelete }) => {
    const { t } = useTranslation();

    const [modalState, setModalState] = useState(false);

    const RemoveModal = () => {
        return (
        <Modal show={modalState} onHide={() => setModalState(false)}>
            <Modal.Header closeButton>
            <Modal.Title>{t('Warning')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {t(
                `Do you really want to remove ${item.title} ? WARNING! Once deleted, this ${item.title} will be removed from ALL projects and published sites. This action cannot be undone.`
            )}
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalState(false)}>
                {t('Cancel')}
            </Button>
            <Button
                variant="danger"
                onClick={() => {
                onDelete?.(item);
                setModalState(false);
                }}
            >
                {t('Remove')}
            </Button>
            </Modal.Footer>
        </Modal>
        );
    };

    return (
        <div className={`${styles.listItem} w-100 mb-2 d-flex bg-light fw-bolder align-items-center rounded`}>
            {
                item.images?.length ?
                    <img className={styles.Image} width={60} height={60} src={item.images[0]?.src} onClick={() => onClick?.(item)}/> :
                    <div className={`${styles.NoImage} d-flex align-items-center justify-content-center`} onClick={() => onClick?.(item)}>
                        <small className={`${styles.NoImageText} text-center bg-white rounded`}>
                            <Image className='text-secondary' size={24} />
                        </small>
                    </div>
            }
            <div className="flex-fill px-2 py-3">
                <h5 className="m-0 fw-normal" onClick={() => onClick?.(item)}>{item.title}</h5>
            </div>
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={
                    <Tooltip id="button-tooltip">
                        {t(Status[item.status].tooltip)}
                    </Tooltip>
                }
            >
            <div className={Status[item.status].className}>
                {Status[item.status].tooltip === 'Active' && <EyeFill></EyeFill>}
                {Status[item.status].tooltip === 'Archived' && <EyeSlash></EyeSlash>}
                {Status[item.status].tooltip === 'Draft' && <EyeSlashFill></EyeSlashFill>}
            </div>
            </OverlayTrigger>
            <div className='p-3'>
                <RemoveModal></RemoveModal>
                <Trash className={`${styles.ItemRemove} text-danger`} onClick={() => setModalState(true)} size={16}></Trash>
            </div>
        </div>
    )
}